
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  data () {
    return {
      showPromoInput: false,
      code: '',
      isLoading: false,
      isValid: false,
      isInvalid: false
    }
  },
  methods: {
    toggleInput () {
      this.showPromoInput = !this.showPromoInput
      this.isInvalid = false
    },
    async checkPromoCode () {
      this.isLoading = true
      this.isValid = false
      this.isInvalid = false
      this.trackEvent('Promo code', `Enter ${this.code}`)
      await this.$store.dispatch('checkout/addCodeToCartItems', { code: this.code, $backend: this.$backend, $matomo: this.$matomo })
      const discount = this.$store.getters['checkout/discount']
      this.isValid = discount > 0
      this.isInvalid = discount === 0
      this.trackEvent('Promo code', `Result ${this.isValid}`, discount)
      this.isLoading = false
    }
  }
}
